import {
  CuratedColumnSymbology,
  CUSTOM_THEME,
  DEFAULT_OPACITY,
  InterpolationTypes,
  PaintColorTypes,
  SymbologyScales,
  SymbologyTypes,
} from 'uf/symbology';

const symbologies: Record<string, Record<string, CuratedColumnSymbology[]>> = {
  '/public/dataset/sonoma_priority_development_areas': {
    abagstatus: [
      {
        type: SymbologyTypes.FILL,
        paint: {
          'fill-color': {
            property: 'abagstatus',
            type: PaintColorTypes.CATEGORICAL,
            stops: [
              { value: 'Final', color: '#a6cee3' },
              { value: 'Proposed', color: '#1f78b4' },
              { value: 'Removed', color: '#b2df8a' },
            ],
          },
          'fill-opacity': DEFAULT_OPACITY,
        },
        display_hints: {
          scale: SymbologyScales.CATEGORICAL,
          distribution: null,
          interpolation: InterpolationTypes.CATEGORICAL,
          theme: CUSTOM_THEME,
        },
      },
    ],
  },
};

export default symbologies;
